import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { CONTACT_INFO } from '@/constants/navigation';
import { Container } from '@/ui';
import { colors } from '@/theme/colors';
export const Footer = () => {
    return (_jsx(FooterContainer, { children: _jsxs(Container, { size: "large", children: [_jsxs(FooterContent, { children: [_jsxs(FooterSection, { children: [_jsx("h3", { children: "Legarta" }), _jsx("p", { children: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0438 \u043E\u0442\u0434\u0435\u043B\u043E\u0447\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0432 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0435" }), _jsxs(FooterAdvantages, { children: [_jsxs(AdvantageItem, { children: [_jsx(AdvantageIcon, { children: "\uD83C\uDFE2" }), _jsx("span", { children: "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0441\u043A\u043B\u0430\u0434" })] }), _jsxs(AdvantageItem, { children: [_jsx(AdvantageIcon, { children: "\uD83D\uDE9A" }), _jsx("span", { children: "\u0411\u044B\u0441\u0442\u0440\u0430\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430" })] }), _jsxs(AdvantageItem, { children: [_jsx(AdvantageIcon, { children: "\uD83D\uDC8E" }), _jsx("span", { children: "\u041A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043E" })] })] })] }), _jsxs(FooterSection, { children: [_jsx("h4", { children: "\u041F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u044F" }), _jsxs(FooterLinks, { children: [_jsx("li", { children: _jsx("a", { href: "/products/plinths", children: "\u041F\u043B\u0438\u043D\u0442\u0443\u0441\u044B" }) }), _jsx("li", { children: _jsx("a", { href: "/products/panels", children: "\u041F\u0430\u043D\u0435\u043B\u0438 \u041F\u0412\u0425" }) }), _jsx("li", { children: _jsx("a", { href: "/products/profiles", children: "\u041F\u0440\u043E\u0444\u0438\u043B\u0438 \u0438 \u0443\u0433\u043E\u043B\u043A\u0438" }) }), _jsx("li", { children: _jsx("a", { href: "/products/cable-channels", children: "\u041A\u0430\u0431\u0435\u043B\u044C-\u043A\u0430\u043D\u0430\u043B\u044B" }) }), _jsx("li", { children: _jsx("a", { href: "/products/kitchen", children: "\u041A\u0443\u0445\u043E\u043D\u043D\u044B\u0435 \u043F\u0430\u043D\u0435\u043B\u0438" }) })] })] }), _jsxs(FooterSection, { children: [_jsx("h4", { children: "\u041E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438" }), _jsxs(FooterLinks, { children: [_jsx("li", { children: _jsx("a", { href: "/about", children: "\u041E \u043D\u0430\u0441" }) }), _jsx("li", { children: _jsx("a", { href: "/about#advantages", children: "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430" }) }), _jsx("li", { children: _jsx("a", { href: "/about#warehouse", children: "\u0421\u043A\u043B\u0430\u0434\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441" }) }), _jsx("li", { children: _jsx("a", { href: "/about#partners", children: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B" }) })] })] }), _jsxs(FooterSection, { children: [_jsx("h4", { children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B" }), _jsxs(ContactInfo, { children: [_jsxs(ContactItem, { children: [_jsx(PhoneOutlined, { style: { color: colors.primary, fontSize: 16 } }), _jsx("span", { children: CONTACT_INFO.phone })] }), _jsxs(ContactItem, { children: [_jsx(MailOutlined, { style: { color: colors.primary, fontSize: 16 } }), _jsx("span", { children: CONTACT_INFO.email })] }), _jsxs(ContactItem, { children: [_jsx(EnvironmentOutlined, { style: { color: colors.primary, fontSize: 16 } }), _jsx("span", { children: CONTACT_INFO.address })] }), _jsxs(ContactItem, { children: [_jsx("span", { style: { color: colors.primary, fontSize: 16 }, children: "\u23F0" }), _jsx("span", { children: CONTACT_INFO.workingHours })] })] })] })] }), _jsxs(FooterBottom, { children: [_jsx(FooterCopyright, { children: _jsx("p", { children: "\u00A9 2024 Legarta. \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B." }) }), _jsx(FooterMadeBy, { children: _jsx("p", { children: "\u0421\u0434\u0435\u043B\u0430\u043D\u043E \u0441 \u2764\uFE0F \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u0435\u0439" }) })] })] }) }));
};
const FooterContainer = styled.footer `
  background: ${colors.backgroundDark};
  color: ${colors.textWhite};
  padding: 60px 0 20px;
  margin-top: 80px;

  @media (max-width: 768px) {
    padding: 40px 0 20px;
  }

  @media (max-width: 480px) {
    padding: 30px 0 20px;
  }
`;
const FooterContent = styled.div `
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;
const FooterSection = styled.div `
  h3 {
    color: ${colors.primary};
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 16px 0;

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  h4 {
    color: ${colors.primary};
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px 0;

    @media (max-width: 480px) {
      font-size: 16px;
    }
  }

  p {
    color: #ccc;
    line-height: 1.6;
    margin: 0 0 20px 0;
  }
`;
const FooterAdvantages = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const AdvantageItem = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ccc;
`;
const AdvantageIcon = styled.span `
  font-size: 20px;
`;
const FooterLinks = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 12px;
  }

  a {
    color: #ccc;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.primary};
    }
  }
`;
const ContactInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ContactItem = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ccc;
`;
const ContactIcon = styled.span `
  color: ${colors.primary};
  font-size: 16px;
`;
const FooterBottom = styled.div `
  border-top: 1px solid #333;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;
const FooterCopyright = styled.div `
  p {
    margin: 0;
    color: #999;
    font-size: 14px;
  }
`;
const FooterMadeBy = styled.div `
  p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }
`;
